
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/topic-collection",
      function () {
        return require("private-next-pages/topic-collection/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/topic-collection"])
      });
    }
  